
import Vue from 'vue';
import { VBtn, VIcon } from 'vuetify/lib';
import _debouce from 'lodash/debounce';

export default Vue.extend({
	name: 'RunnitCarousel',
	props: {
		items: { type: Array, default: () => [] },
		// Name of a property on each item that uniquely identifies it. Without
		// this the list falls back to keying by index, which lets Vue recycle a
		// DOM node for a different item when the list is inserted into.
		itemKeyProp: { type: String, default: null },
		gap: { type: String, default: '16px' },
		includeViewAll: { type: Boolean, default: false },
		viewAllText: { type: String, default: 'View All' },
		viewAllStyles: { type: Object, default: () => { } },
		useCircleButtons: { type: Boolean, default: false }
	},
	data () {
		return {
			updateScrollStateDebounce: () => { },
			canScrollLeft: false,
			canScrollRight: false,
		};
	},
	mounted () {
		this.updateScrollStateDebounce = _debouce(this.updateScrollState, 100);
		this.updateScrollStateDebounce();
		window.addEventListener('resize', this.updateScrollStateDebounce);
		const wrapper = this.$refs.carouselWrapper as HTMLElement;
		if (wrapper) {
			wrapper.addEventListener('scroll', this.updateScrollStateDebounce);
		}
	},
	beforeDestroy () {
		const wrapper = this.$refs.carouselWrapper as HTMLElement;
		if (wrapper) {
			wrapper.removeEventListener('scroll', this.updateScrollStateDebounce);
		}
		window.removeEventListener('resize', this.updateScrollStateDebounce);
	},
	watch: {
		items: {
			immediate: true,
			handler () {
				this.updateScrollStateDebounce();
			}
		},
	},
	methods: {
		getItemKey (item: unknown, index: number): string | number {
			if (!this.itemKeyProp || !item || typeof item !== 'object') return index;
			const key = (item as Record<string, unknown>)[this.itemKeyProp];
			return typeof key === 'string' || typeof key === 'number' ? key : index;
		},
		scrollLeft () {
			const wrapper = this.$refs.carouselWrapper as HTMLElement;
			wrapper.scrollBy({ left: -wrapper.offsetWidth, behavior: 'smooth' });
			this.updateScrollStateDebounce();
		},
		scrollRight () {
			const wrapper = this.$refs.carouselWrapper as HTMLElement;
			wrapper.scrollBy({ left: wrapper.offsetWidth, behavior: 'smooth' });
			this.updateScrollStateDebounce();
		},
		updateScrollState () {
			const wrapper = this.$refs.carouselWrapper as HTMLElement;
			if (!wrapper) return;

			this.canScrollLeft = wrapper.scrollLeft > 0;
			this.canScrollRight =
				wrapper.scrollLeft + wrapper.offsetWidth < wrapper.scrollWidth;
		},
	},
});
